import { render, staticRenderFns } from "./InsuranceIndex.vue?vue&type=template&id=660cc02a"
import script from "./InsuranceIndex.vue?vue&type=script&lang=js"
export * from "./InsuranceIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports